import { render, staticRenderFns } from "./SingularityCanvas.vue?vue&type=template&id=506131f1&"
import script from "./SingularityCanvas.vue?vue&type=script&lang=ts&"
export * from "./SingularityCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityCanvas.vue?vue&type=style&index=0&id=506131f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports